import React from 'react';
import Link from 'gatsby-link';

const Footer = ({ siteTitle }) => (
    <div className="footer">
        <div className="footer-bottom py-4">
            <div className="container">
                <div className="row cols-lg-space col-lg-space align-items-center">
                    <div className="col-lg-3 col-12">
                        <div className="copyright">
                            <ul className="copy-links no-margin">
                                <li>
                                    © 2018 Jamocha Media
                                </li>
                                <li>
                                    <a target="_blank" href="https://app.termly.io/document/terms-of-use-for-website/bdbba3ba-b967-4ec8-a13e-d722b4e60da6">Terms</a>
                                </li>
                                <li>
                                    <a target="_blank" href="https://app.termly.io/document/privacy-policy/b0b68a8b-c9ac-4ba6-95bf-1f382032266c">Privacy policy</a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="text-center">
                            <ul className="footer-menu footer-menu-sm">
                                <li>
                                    <Link to="/">Home</Link>
                                </li>
                                <li>
                                    <a href="/FAQ">FAQ</a>
                                </li>
                                <li>
                                    <Link to="/brew-crew">Brew Crew</Link>
                                </li>
                                {/* <li>
                                    <a href="https://medium.com/jamocha-cafe" target="_blank" >Blog</a>
                                </li> */}
                                <li>
                                    <a href="mailto:hello@jamochamedia.com">Contact</a>
                                </li>
                                <li>
                                    <Link to="/writers">Apply to Write</Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-3">
                        <div className="text-xs-center text-sm-right">
                            <ul className="social-media social-media--style-1-v4">
                                <li>
                                    <a href="https://www.facebook.com/jamochamedia/" className="facebook" target="_blank" title="Facebook">
                                        <i className="fa fa-facebook"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/jamochamedia/" className="instagram" target="_blank">
                                        <i className="fa fa-instagram"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.youtube.com/channel/UCbQwt_XyZN-7gkjDqtsDjuA" className="youtube" target="_blank">
                                        <i className="fa fa-youtube"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.linkedin.com/company/jamocha-media/" className="linkedin" target="_blank">
                                        <i className="fa fa-linkedin"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="mailto:hello@jamochamedia.com" className="envelope" target="_blank">
                                        <i className="fa fa-envelope"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.facebook.com/groups/dailydeck/" className="users" target="_blank">
                                        <i className="fa fa-users"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js